import { useActivitiesContext } from '../../../../context'

export function useData() {
  const [{ current }] = useActivitiesContext()

  const backButtonTitle = current ? 'Activity' : 'Activities'
  const title = current ? 'Edit Activity' : 'Create Activity'

  return {
    backButtonTitle,
    title,
  }
}
